import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { scrollToSection } from "@/utils/scroll";

export default function CtaBand() {
  return (
    <section className="relative pb-20 pt-4 md:pb-28" data-testid="cta-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="hero-bg noise relative overflow-hidden rounded-[2rem] border border-electric/25 px-6 py-16 text-center shadow-[0_24px_70px_rgba(2,6,23,0.12)] sm:px-16 md:py-20">
            <div className="grid-lines absolute inset-0" aria-hidden="true" />
            <div className="relative">
              <p className="mb-4 text-xs font-bold uppercase tracking-[0.25em] text-electric">Get started today</p>
              <h2 className="mx-auto max-w-2xl font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
                Ready to Upgrade Your Entertainment?
              </h2>
              <p className="mx-auto mt-5 max-w-xl text-base text-slate-500">
                Join the hub and start streaming on the devices you already own — setup takes minutes.
              </p>
              <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
                <button
                  data-testid="cta-view-plans-button"
                  onClick={() => scrollToSection("#plans")}
                  className="btn-primary inline-flex items-center gap-2 rounded-full px-8 py-4 text-base"
                >
                  View Plans <ArrowRight className="h-4 w-4" />
                </button>
                <button
                  data-testid="cta-contact-us-button"
                  onClick={() => scrollToSection("#contact")}
                  className="btn-ghost inline-flex items-center rounded-full px-8 py-4 text-base"
                >
                  Contact Us
                </button>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
